import baseAPI from "@/http";

const router = "api/plano-trabalho";

export const planoTrabalhoApi = {
  list: (municipioId) => baseAPI.get(`${router}/${municipioId}`),
  save: (payload) => baseAPI.put(`${router}`, payload),
  download: (municipioId) =>
    baseAPI.get(`${router}/${municipioId}/pdf`, { responseType: "arraybuffer" }),
};
